import { ToastContainer } from 'react-toastify';
import {ThemeProvider} from "@material-ui/core";
import {atencyThemeV1} from "./utils/theme";
import {Provider} from 'react-redux';
import configureStore from './store/configureStore';
import * as React from "react";
import AppRouter from './routes/AppRouter';


const store = configureStore();
const App = () =>(
    
    <ThemeProvider theme={atencyThemeV1}>
      
        <Provider store={store}>
            <AppRouter />
        </Provider>
        <ToastContainer  />

    </ThemeProvider>   
);
export default App;